<template>
  <div class="eddy-current-viz">
    
    <div class="viz-header" >
      <div class="brief" v-latex="knowledgePoint"></div>
      <div class="formula" v-latex><strong>公式：</strong>Eddy Currents & Damping</div>
    </div>

    <div class="main-layout vertical">
      <!-- 仿真区：磁铁经过金属板 -->
      <div class="canvas-item simulation">
         <svg width="100%" height="220" viewBox="0 0 400 220">
            <!-- 金属板 -->
            <rect x="50" y="140" width="300" height="20" fill="#7f8c8d" rx="4" />
            
            <!-- 涡流 (椭圆环) -->
            <g v-if="Math.abs(velocity) > 0.5" :transform="`translate(${magnetX}, 150)`">
                <ellipse cx="0" cy="0" rx="30" ry="10" fill="none" stroke="#ffd700" stroke-width="2" opacity="0.6">
                  <animate attributeName="stroke-dasharray" from="10,5" to="5,10" dur="0.2s" repeatCount="indefinite" />
                </ellipse>
                <ellipse cx="0" cy="0" rx="15" ry="5" fill="none" stroke="#ffd700" stroke-width="1.5" opacity="0.4" />
            </g>

            <!-- 磁铁 -->
            <g :transform="`translate(${magnetX}, ${magnetY})`">
               <rect x="-15" y="-40" width="30" height="20" fill="#ff4757" /> <text x="-5" y="-25" fill="#fff" font-size="10">N</text>
               <rect x="-15" y="-20" width="30" height="20" fill="#2f3542" /> <text x="-5" y="-5" fill="#fff" font-size="10">S</text>
            </g>
         </svg>

         <div class="hud-top">
            <div class="stat">
               <label>电磁阻尼</label>
               <span class="val">{{ (velocity * 10).toFixed(1) }} m/s</span>
            </div>
         </div>
      </div>

      <!-- 参数控制 -->
      <div class="bottom-controls">
         <div class="control-card glass">
            <div class="row center">
               <el-button type="primary" size="mini" @click="reset">释放磁铁</el-button>
               <el-button size="mini" @click="toggleSlotted">切换：{{ isSlotted ? '普通板' : '开槽板' }}</el-button>
            </div>
         </div>

         <div class="law-hint">
            <p><strong>物理原理：</strong>当磁铁相对于导体运动时，导体内部会产生环形电流（<strong>涡流</strong>）。根据楞次定律，涡流产生的磁场会阻碍磁铁运动，产生<strong>电磁阻尼</strong>。开槽可以有效减弱涡流。</p>
         </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'EddyCurrentViz',
  props: { knowledgePoint: { type: String, default: '' } },
  data() {
    return {
      magnetX: 200,
      magnetY: 50,
      velocity: 0,
      isSlotted: false,
      running: true
    }
  },
  methods: {
    reset() {
      this.magnetX = 50;
      this.magnetY = 120;
      this.velocity = 5;
    },
    toggleSlotted() {
      this.isSlotted = !this.isSlotted;
    },
    animate() {
       if (!this.running) return;
       
       if (this.velocity > 0) {
          this.magnetX += this.velocity;
          // Magnetic damping force
          const drag = this.isSlotted ? 0.02 : 0.15;
          this.velocity *= (1 - drag);
          
          if (this.magnetX > 350) {
             this.velocity = 0;
          }
       }

       requestAnimationFrame(this.animate);
    }
  },
  mounted() { this.animate(); },
  beforeDestroy() { this.running = false; }
}
</script>

<style scoped lang="scss">
.eddy-current-viz { flex: 1; display: flex; flex-direction: column; gap: 12px; height: 100%; overflow: hidden; }
.viz-header { display: flex; justify-content: space-between; align-items: center; .title { font-size: 1rem; color: #fff; } .formula-chip { color: #ffd700; background: rgba(255,215,0,0.1); padding: 4px 12px; border-radius: 8px; font-weight: bold; } }
.canvas-item { 
   background: #000; border-radius: 12px; position: relative; border: 1px solid rgba(255,255,255,0.05);
   .hud-top { position: absolute; top: 15px; left: 15px; .val { color: #ff4757; font-weight: bold; } }
}
.bottom-controls { flex: 0.5; display: flex; flex-direction: column; gap: 10px; }
.control-card { background: rgba(255,255,255,0.03); border-radius: 12px; padding: 15px; .row.center { display: flex; justify-content: center; gap: 15px; } }
.law-hint { background: rgba(255, 215, 0, 0.05); padding: 12px 18px; border-radius: 12px; p { margin: 0; font-size: 0.75rem; color: #aaa; line-height: 1.5; strong { color: #fff; } } }
</style>
